import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import SocialIcons from "@/components/SocialIcons";

const SocialMediaCard = () => {
  return (
    <Card className="shadow-xl bg-white/80 backdrop-blur-sm border-2 border-golden-orange/20">
      <CardHeader>
        <CardTitle className="text-2xl text-golden-orange">
          Follow Our Adventures
        </CardTitle>
        <p className="text-gray-600 mt-2">
          Stay up to date with Bobo & Teedee® on social media!
        </p>
      </CardHeader>
      <CardContent>
        <div className="flex justify-center">
          <SocialIcons />
        </div>
        <div className="mt-6 grid grid-cols-1 gap-3 text-center">
          <div className="bg-red-50 p-3 rounded-lg">
            <p className="text-sm">
              <strong>YouTube:</strong> New episodes!
            </p>
          </div>
          <div className="bg-pink-50 p-3 rounded-lg">
            <p className="text-sm">
              <strong>Instagram:</strong> Behind-the-scenes content
            </p>
          </div>
          <div className="bg-blue-50 p-3 rounded-lg">
            <p className="text-sm">
              <strong>Facebook:</strong> Community updates & events
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SocialMediaCard;
